import { dateFormatting } from "./apiHelper";
import { phoneCountryCodes } from "./constant";

export const buildEntitySearchValues = ({
    entity, // "lead" | "task" | "salesOrder" | "invoice"
    currentUser,
    specificRolePermission,
    ownerlist,
    myTeam,
    statusData,
    daysAgo,
    today,
    isAllManage,
    isTeamManage,
    internationalise,
    handleValidateCodevalue,
}) => {
    const list = (
        isAllManage ? ownerlist :
        isTeamManage ? myTeam :
        [{
            firstName: currentUser?.firstname,
            lastName: currentUser?.lastname,
            id: currentUser?.userId,
        }]
    ) || [];

    const ownerlistdata = list.map(item => ({
        name: `${item.firstName} ${item.lastName}`,
        id: item.id,
    }));

    const myOrgOption = { 
        name: handleValidateCodevalue(internationalise, "COMMON_ENTIRE_ORG"), 
        id: "COMMON_ENTIRE_ORG" 
    };
    const myTeamOption = { 
        name: handleValidateCodevalue(internationalise, "COMMON_MY_TEAM"), 
        id: "COMMON_MY_TEAM" 
    };

    let newList = [...ownerlistdata];
    if (isAllManage) newList.push(myOrgOption);
    if ((myTeam?.length > 0 && isTeamManage) 
        || isAllManage) {
        newList.push(myTeamOption);
    }

    const filteredOwner = ownerlistdata.find(item => item.id === currentUser?.userId);

    let defaultOwner = filteredOwner;
    const status = (statusData || [])?.filter(item => {
        const name = item?.systemLookupCode?.name;
        return !name.includes("CLOSED") && !name.includes("CANCELLED") && !name.includes("DEAL_CLOSED");
    });

    if (isAllManage) defaultOwner = myOrgOption;
    else if (isTeamManage && !isAllManage) {
        defaultOwner = myTeamOption;
    }

    const updatedSearch = {
        status: status || [],
        selectedOwner: defaultOwner ? [defaultOwner] : [],
        ownerName: defaultOwner?.name ?? null,
        updatedFrom: daysAgo ? dateFormatting(daysAgo) : null,
        updatedTo: today ? dateFormatting(today) : null,
    };

    // Leads need phoneCountryCode
    if (entity === "lead") {
        updatedSearch.phoneCountryCode = phoneCountryCodes?.phoneCountryCode;
    }
    // Save search state in 

    return { updatedSearch, newList };
};
